import React from "react";
import PropTypes from "prop-types";

/**
 * 
 * Kontener zawierajacy taby. Obsluguje renderowanie tabów, zaznaczanie wybranego taba, renderowanie zawartosci wybranego taba
 * 
 * https://medium.com/@diegocasmo/a-simple-react-tabs-component-47cac2cfbb5
 */
class Tabs extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTabIndex: this.props.defaultActiveTabIndex
    };
  }

  /**
   * Obsługa klikniecia na wybany tab
   * 
   * @param {number} tabIndex - index taba który został klikniety (numeracja od 0)
   */
  handleTabClick = tabIndex => {

    this.setState({
      //opcja jesli chcemy miec mozliwosc odznaczania
      //activeTabIndex: tabIndex === this.state.activeTabIndex ? this.props.defaultActiveTabIndex : tabIndex
      /**
       * {number} index aktywngo taba
       */
      activeTabIndex: tabIndex
    })

  };

  /**
   * Renderuje wszyskie taby - same taby bez zawartosci
   */
  renderTabs() {
    const { children } = this.props;
    return React.Children.map(children, (child, index) => {
      return React.cloneElement(child, {
        onClick: this.handleTabClick,
        index: index,
        isActive: index === this.state.activeTabIndex
      })
    });
  }

  /**
   * Renderuje zawartość aktualnie aktywnego taba
   */
  renderActiveTabContent() {
    const { children } = this.props;
    const { activeTabIndex } = this.state;

    //jesli dzieci sa tablica - to zwracamy zawartosc odpowiedniego indexa
    if (children instanceof Array) {
      if (children[activeTabIndex]) {
        return children[activeTabIndex].props.children;
      }
    } else {
      //dzieci to pojedynczy element - zwrcamy zawartość bezpośrednio
      return children.props.children;
    }

  }

  render() {
    return (
      <div>
        <div className="w3-row">
          {this.renderTabs()}
        </div>
        <div className="w3-container">
          {/* dajemy ekstra margines */}
          <div className="w3-margin-top"></div>
          {/*renderujemy zawartosc taba*/}
          {this.renderActiveTabContent()}
        </div>
      </div>
    );
  }
}

Tabs.propTypes = {
  /**
   * Określa index taba - wybranego domyślnie
   */
  defaultActiveTabIndex: PropTypes.number,
  /**
   * Dzieci, czyli pojedyncze elementy Tab. Jesli jest wiecej elementów Tab - to dzieci są tablicą, jesli nie to jest pojedyńczy element.
   * Dzieci są wymagane, ponieważ określenie elementy Tabs, bez żadnego Tab nie ma sensu
   */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};

Tabs.defaultProps = {
  /**
   * Określa index taba - wybranego domyślnie - numeracja automatyczna od 0, czyli zaznaczamy pierwszy element
   */
  defaultActiveTabIndex: 0
};

export default Tabs;
